function accordManage() {
  const accordions = document.querySelectorAll(".footer-block--menu .accordion");
  const isMobileView = window.innerWidth <= 1399;

  accordions.forEach((accordion) => {
    const panel = document.getElementById(accordion.getAttribute("aria-controls"));

    if (isMobileView) {
      // Mobile and tablet behavior
      const isExpanded = accordion.getAttribute("aria-expanded") === "true";

      // Initialize the state for mobile
      if (!isExpanded) {
        panel.setAttribute("hidden", "");
      }

      // Add click event listener
      const clickHandler = () => {
        const isExpanded = accordion.getAttribute("aria-expanded") === "true";
        accordion.setAttribute("aria-expanded", !isExpanded);

        if (!isExpanded) {
          panel.removeAttribute("hidden");
          accordion.classList.add("active");
        } else {
          panel.setAttribute("hidden", "");
          accordion.classList.remove("active");
        }
      };

      // Add keyboard navigation
      const keydownHandler = (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          accordion.click();
        }
      };

      accordion.addEventListener("click", clickHandler);
      accordion.addEventListener("keydown", keydownHandler);

      // Store handlers for cleanup
      accordion._clickHandler = clickHandler;
      accordion._keydownHandler = keydownHandler;
    } else {
      // Desktop behavior
      // Remove event listeners if they exist
      if (accordion._clickHandler) {
        accordion.removeEventListener("click", accordion._clickHandler);
        delete accordion._clickHandler;
      }
      if (accordion._keydownHandler) {
        accordion.removeEventListener("keydown", accordion._keydownHandler);
        delete accordion._keydownHandler;
      }

      // Initialize the state for desktop
      accordion.setAttribute("aria-expanded", "true");
      panel.removeAttribute("hidden");
      accordion.classList.remove("active");
    }
  });
}

// Initialize accordions on page load
document.addEventListener("DOMContentLoaded", accordManage);

